import { FAL_IMAGE_REFERENCE_REJECTION_BYTES } from "./upload-limits";

export const ADS_EXPRESS_REFERENCE_UPLOAD_PATH = "/api/ads-express/reference-upload";
export const ADS_EXPRESS_REFERENCE_ACCEPT = "image/png,image/jpeg,image/webp";
export const ADS_EXPRESS_REFERENCE_MAX_UPLOAD_BYTES = FAL_IMAGE_REFERENCE_REJECTION_BYTES - 1;
export const ADS_EXPRESS_REFERENCE_SIZE_ERROR =
  "Reference images must be less than 25 MB (25,000,000 bytes) each.";
export const ADS_EXPRESS_REFERENCE_UPLOAD_GUIDANCE =
  "Still PNG, JPG or WebP images, less than 25 MB each. Templates, product photos, logos and persona images also count toward the selected model's image limit.";

// Retain the existing, stricter application/Fal transport allowance, not
// OpenAI's larger direct-API allowance. Decimal MB; the boundary is exclusive.
export function adsExpressReferenceUploadError(file: { size: number; type: string }): string | null {
  if (!Number.isSafeInteger(file.size) || file.size <= 0) return "Choose a non-empty reference image.";
  if (file.size >= FAL_IMAGE_REFERENCE_REJECTION_BYTES) {
    return ADS_EXPRESS_REFERENCE_SIZE_ERROR;
  }
  if (!ADS_EXPRESS_REFERENCE_ACCEPT.split(",").includes(file.type)) {
    return "Use a still PNG, JPG or WebP reference image.";
  }
  return null;
}
